import { useCallback } from 'react';
import { Checkbox, Header, Text, VStack } from '@direct-frontend/components';
import { logEventString } from '@adv-frontend/yastore-modules/logger';
import { useConfirm } from '#shared/lib/hooks';
import { constructorProductLoggingEvents } from '../lib/constructorProductLoggingEvents';
import { detachConstructorSection, getConstructorSectionSettings } from '../model/slices';
import { getConstructorCountChildren } from './useConstructorCountChildren';

export const useConstructorDetachSection = () => {
    const { confirm, renderConfirmModal } = useConfirm();
    const detachSection = useCallback(
        async (pageId: string, sectionInstanceId: string) => {
            const sectionSettings = getConstructorSectionSettings(pageId, sectionInstanceId);

            if (!sectionSettings) {
                return;
            }

            let detachAll = false;

            const { childrenCount } = getConstructorCountChildren(sectionSettings.id);

            if (sectionSettings.section_type === 'parent' && childrenCount > 0) {
                const isConfirmed = await confirm({
                    title: null,
                    bodyText: (
                        <VStack gap="6">
                            <Header level="h2" textAlign="left">
                                Отвязать от компонента?
                            </Header>
                            <Text size="m" role="supplementary" textAlign="left">
                                Секция станет обычной. Чтобы сохранить связку компонента, назначим одну из дочерних
                                секций родительской.
                            </Text>
                            <Checkbox onChange={(isSelected) => (detachAll = isSelected)} size="m">
                                <Text>Преобразовать все секции компонента в обычные</Text>
                            </Checkbox>
                        </VStack>
                    ),
                    applyText: 'Отвязать',
                });

                if (!isConfirmed) {
                    return;
                }
            }

            logEventString(constructorProductLoggingEvents.SectionType.Detach, 'true', {
                pageId,
                sectionInstanceId,
                detachAll: Boolean(detachAll),
            });

            detachConstructorSection({ pageId, sectionInstanceId, detachAll });
        },
        [confirm]
    );

    return { detachSection, renderConfirmModal };
};
